<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getSitePlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>

    <div v-if="getSitePlanCarbonTracker()" class="card card-details">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
          <UpdateSitePlanCarbonTrackerComponent
              :id = parseInt(id)
              :current_2022 = getSitePlanCarbonTracker().current_2022
              :current_2023 = getSitePlanCarbonTracker().current_2023
              :current_2024 = getSitePlanCarbonTracker().current_2024
              :current_2025 = getSitePlanCarbonTracker().current_2025
              :current_2026 = getSitePlanCarbonTracker().current_2026
              :current_2027 = getSitePlanCarbonTracker().current_2027
              :current_2028 = getSitePlanCarbonTracker().current_2028
              :current_2029 = getSitePlanCarbonTracker().current_2029
              :current_2030 = getSitePlanCarbonTracker().current_2030

        />
    </div>
  </div>
</div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory, truncatechars } from "@/common/general.js";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"
import UpdateSitePlanCarbonTrackerComponent from "@/components/site_plans/UpdateSitePlanCarbonTrackerComponent.vue";

export default {
  name: "SitePlanCarbonTracker",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    NoPermissionComponent,
    UpdateSitePlanCarbonTrackerComponent,
  },
  data() {
    return {
      opportunity_list: true,
      climate_graphs: true,
      financial_graphs: true,
      opportunity_details: false

    }
  },
  methods: {
    ...mapGetters(["getSitePlanData", "getSitePlanCarbonTracker", "getUsername", "isLoggedIn","getFormError"]),
    ...mapActions(["fetchSitePlanData", "performSetFormError", "fetchSitePlanCarbonTracker"]),
    truncatechars: truncatechars,
    hasHistory: hasHistory,
    getSitePlanDetails() {
      this.fetchSitePlanData({"id": this.id})
    },
    getSitePlanCarbonTrackerDetails() {
      this.fetchSitePlanCarbonTracker({"id": this.id})
    }
  },
  computed: {

  },
  created() {
    this.performSetFormError(null);
    this.getSitePlanDetails();
    this.getSitePlanCarbonTrackerDetails();
    document.title = "Carbon Tracker";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.chosenId = to.params.id;
    this.getDivisionPlanDetails();
    this.getSitePlanCarbonTrackerDetails();
    next();
  }

}
</script>

